import { useCallback } from "react";
import { useRouter } from "expo-router";
import { ScreenContainer } from "@src/components";
import { TabsHeader } from "@src/components/TabsHeader";
import { useSiteWideDrawer } from "@src/components/AppDrawer/SiteWideDrawerProvider.native";
import { useTenantId } from "@src/features/tenants";
import { SiteSelector } from "@src/features/alarms/components/SiteSelector";

export function SiteWideAlarmsScreen() {
  const router = useRouter();
  const { openDrawer } = useSiteWideDrawer();
  const tenantId = useTenantId();

  const handleHamburgerMenuPress = useCallback(() => {
    openDrawer();
  }, [openDrawer]);

  const handleSitePress = useCallback(
    (siteId: string) => {
      router.push(`/tenants/${tenantId}/alarm-settings/${siteId}` as never);
    },
    [router, tenantId],
  );

  return (
    <ScreenContainer edges={["top"]}>
      <TabsHeader
        onHamburgerMenuPress={handleHamburgerMenuPress}
        showLogo={false}
        title="Controls"
        headerShadowVisible
        selectedSiteName={null}
      />
      <SiteSelector onSitePress={handleSitePress} />
    </ScreenContainer>
  );
}
